module.exports = __webpack_public_path__ + "img/transfer1.89ced994.png";